export const modalArt = (
    <svg
        width="292px"
        height="159px"
        viewBox="0 0 292 159"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Artboard</title>
        <desc>Created with Sketch.</desc>
        <defs>
            <path
                d="M11.9301407,4.6686553 L4.90716991,4.6686553 L4.90716991,1.6686553 L11.9301407,1.6686553 L14.9301407,1.6686553 L14.9301407,19.6686553 L11.9301407,19.6686553 L11.9301407,4.6686553 Z"
                id="path-1"
            ></path>
        </defs>
        <g
            id="Artboard"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <path
                d="M117.065217,41.397635 L191.282051,41.397635 L199.18361,41.397635 C201.843629,41.397635 204,43.5540061 204,46.2140247 L204,105.282051 C204,112.30598 198.30598,118 191.282051,118 L98.0614614,118 C88.0863917,118 80,109.913608 80,99.9385386 L80,41.397635 L80,38 C80,35.790861 81.790861,34 84,34 L113.065217,34 C115.274356,34 117.065217,35.790861 117.065217,38 L117.065217,41.397635 Z"
                id="folder-back"
                fill="#1B2653"
            ></path>
            <g
                id="report"
                transform="translate(122.000000, 16.000000)"
            >
                <g
                    id="Group"
                    transform="translate(53.000000, 40.500000) rotate(-360.000000) translate(-53.000000, -40.500000) "
                    fill="#FFFFFF"
                    stroke="#EFF4F9"
                    strokeWidth="2"
                >
                    <path
                        d="M4,1 C2.34314575,1 1,2.34314575 1,4 L1,76.5783665 C1,78.2352208 2.34314575,79.5783665 4,79.5783665 L101.054788,79.5783665 C102.711642,79.5783665 104.054788,78.2352208 104.054788,76.5783665 L104.054788,4 C104.054788,2.34314575 102.711642,1 101.054788,1 L4,1 Z"
                        id="Rectangle-2-Copy-25"
                    ></path>
                </g>
                <g
                    id="Group-6"
                    transform="translate(80.000000, 7.000000)"
                    fill="#D6E4F2"
                >
                    <polygon
                        id="Rectangle-3"
                        points="0.228355121 0 17.2871261 0 17.2871261 8 0.228355121 8"
                    ></polygon>
                    <polygon
                        id="Rectangle-3-Copy-2"
                        points="0.228355121 24 17.2871261 24 17.2871261 32 0.228355121 32"
                    ></polygon>
                    <polygon
                        id="Rectangle-3-Copy"
                        points="0.228355121 12 17.2871261 12 17.2871261 20 0.228355121 20"
                    ></polygon>
                    <polygon
                        id="Rectangle-3-Copy-3"
                        points="0.228355121 36 17.2871261 36 17.2871261 44 0.228355121 44"
                    ></polygon>
                    <polygon
                        id="Rectangle-3-Copy-4"
                        points="0.228355121 48 17.2871261 48 17.2871261 56 0.228355121 56"
                    ></polygon>
                    <polygon
                        id="Rectangle-3-Copy-5"
                        points="0.228355121 60 17.2871261 60 17.2871261 68 0.228355121 68"
                    ></polygon>
                </g>
                <g
                    id="Group-3"
                    transform="translate(54.000000, 7.000000)"
                    fill="#D6E4F2"
                    fillRule="nonzero"
                >
                    <rect
                        id="Rectangle"
                        x="21"
                        y="0"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle-Copy"
                        x="18"
                        y="3"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-2"
                        x="15"
                        y="0"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-4"
                        x="9"
                        y="0"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-5"
                        x="3"
                        y="0"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-3"
                        x="12"
                        y="3"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-7"
                        x="0"
                        y="5"
                        width="2"
                        height="3"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-6"
                        x="6"
                        y="0"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle"
                        x="21"
                        y="12"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle-Copy"
                        x="18"
                        y="15"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-2"
                        x="15"
                        y="15"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-4"
                        x="9"
                        y="15"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-5"
                        x="3"
                        y="17"
                        width="2"
                        height="3"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-3"
                        x="12"
                        y="15"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-7"
                        x="0"
                        y="17"
                        width="2"
                        height="3"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-6"
                        x="6"
                        y="12"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle"
                        x="21"
                        y="48"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle-Copy"
                        x="18"
                        y="51"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-2"
                        x="15"
                        y="51"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-4"
                        x="9"
                        y="51"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-5"
                        x="3"
                        y="53"
                        width="2"
                        height="3"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-3"
                        x="12"
                        y="51"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-7"
                        x="0"
                        y="53"
                        width="2"
                        height="3"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-6"
                        x="6"
                        y="48"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle"
                        x="21"
                        y="28"
                        width="2"
                        height="4"
                    ></rect>
                    <rect
                        id="Rectangle-Copy"
                        x="18"
                        y="27"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-2"
                        x="15"
                        y="24"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-4"
                        x="9"
                        y="28"
                        width="2"
                        height="4"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-5"
                        x="3"
                        y="24"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-3"
                        x="12"
                        y="27"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-7"
                        x="0"
                        y="26"
                        width="2"
                        height="6"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-6"
                        x="6"
                        y="26"
                        width="2"
                        height="6"
                    ></rect>
                    <rect
                        id="Rectangle"
                        x="21"
                        y="64"
                        width="2"
                        height="4"
                    ></rect>
                    <rect
                        id="Rectangle-Copy"
                        x="18"
                        y="63"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-2"
                        x="15"
                        y="60"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-4"
                        x="9"
                        y="64"
                        width="2"
                        height="4"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-5"
                        x="3"
                        y="60"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-3"
                        x="12"
                        y="63"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-7"
                        x="0"
                        y="62"
                        width="2"
                        height="6"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-6"
                        x="6"
                        y="62"
                        width="2"
                        height="6"
                    ></rect>
                    <rect
                        id="Rectangle"
                        x="21"
                        y="42"
                        width="2"
                        height="2"
                    ></rect>
                    <rect
                        id="Rectangle-Copy"
                        x="18"
                        y="40"
                        width="2"
                        height="4"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-2"
                        x="15"
                        y="38"
                        width="2"
                        height="6"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-4"
                        x="9"
                        y="42"
                        width="2"
                        height="2"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-5"
                        x="3"
                        y="36"
                        width="2"
                        height="8"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-3"
                        x="12"
                        y="39"
                        width="2"
                        height="5"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-7"
                        x="0"
                        y="41"
                        width="2"
                        height="3"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-6"
                        x="6"
                        y="42"
                        width="2"
                        height="2"
                    ></rect>
                </g>
                <polygon
                    id="Rectangle-3-Copy-6"
                    fill="#EFF4F9"
                    transform="translate(30.783214, 11.000000) rotate(-360.000000) translate(-30.783214, -11.000000) "
                    points="20.1396514 7 41.4267774 7 41.4267774 15 20.1396514 15"
                ></polygon>
                <polygon
                    id="Rectangle-3-Copy-7"
                    fill="#EFF4F9"
                    transform="translate(26.783214, 35.000000) rotate(-360.000000) translate(-26.783214, -35.000000) "
                    points="20.1396514 31 33.4267774 31 33.4267774 39 20.1396514 39"
                ></polygon>
                <polygon
                    id="Rectangle-3-Copy-8"
                    fill="#EFF4F9"
                    transform="translate(34.283214, 23.000000) rotate(-360.000000) translate(-34.283214, -23.000000) "
                    points="20.1396514 19 48.4267774 19 48.4267774 27 20.1396514 27"
                ></polygon>
                <polygon
                    id="Rectangle-3-Copy-9"
                    fill="#EFF4F9"
                    transform="translate(31.783214, 47.000000) rotate(-360.000000) translate(-31.783214, -47.000000) "
                    points="20.1396514 43 43.4267774 43 43.4267774 51 20.1396514 51"
                ></polygon>
                <polygon
                    id="Rectangle-3-Copy-24"
                    fill="#EFF4F9"
                    transform="translate(33.783214, 59.000000) rotate(-360.000000) translate(-33.783214, -59.000000) "
                    points="20.1396514 55 47.4267774 55 47.4267774 63 20.1396514 63"
                ></polygon>
                <polygon
                    id="Rectangle-3-Copy-25"
                    fill="#EFF4F9"
                    transform="translate(27.783214, 71.000000) rotate(-360.000000) translate(-27.783214, -71.000000) "
                    points="20.1396514 67 35.4267774 67 35.4267774 75 20.1396514 75"
                ></polygon>
                <polygon
                    id="Rectangle-3-Copy-6"
                    fill="#3063BB"
                    transform="translate(11.000000, 11.000000) rotate(-360.000000) translate(-11.000000, -11.000000) "
                    points="7 7 15 7 15 15 7 15"
                ></polygon>
                <polygon
                    id="Rectangle-3-Copy-7"
                    fill="#3063BB"
                    transform="translate(11.000000, 35.000000) rotate(-360.000000) translate(-11.000000, -35.000000) "
                    points="7 31 15 31 15 39 7 39"
                ></polygon>
                <polygon
                    id="Rectangle-3-Copy-8"
                    fill="#3063BB"
                    transform="translate(11.000000, 23.000000) rotate(-360.000000) translate(-11.000000, -23.000000) "
                    points="7 19 15 19 15 27 7 27"
                ></polygon>
                <polygon
                    id="Rectangle-3-Copy-9"
                    fill="#3063BB"
                    transform="translate(11.000000, 47.000000) rotate(-360.000000) translate(-11.000000, -47.000000) "
                    points="7 43 15 43 15 51 7 51"
                ></polygon>
                <polygon
                    id="Rectangle-3-Copy-24"
                    fill="#4F8DF9"
                    transform="translate(11.000000, 59.000000) rotate(-360.000000) translate(-11.000000, -59.000000) "
                    points="7 55 15 55 15 63 7 63"
                ></polygon>
                <polygon
                    id="Rectangle-3-Copy-25"
                    fill="#4F8DF9"
                    transform="translate(11.000000, 71.000000) rotate(-360.000000) translate(-11.000000, -71.000000) "
                    points="7 67 15 67 15 75 7 75"
                ></polygon>
            </g>
            <path
                d="M183.657797,117.991761 L84.0409743,117.991761 C77.3909278,117.991761 72,112.600833 72,105.950786 L72,65.4211845 L72,60 C72,57.790861 73.790861,56 76,56 L105.238765,56 C107.447904,56 109.238765,57.790861 109.238765,60 L109.238765,64.6701763 L180.104003,64.6701763 C182.099017,64.6701763 183.716295,66.2874546 183.716295,68.2824686 L183.716295,102.913269 C186.706033,116.873225 203.995623,115.110088 203.995623,104.811829 C204.109489,109.83594 202.001689,113.613943 197.672221,116.145837 C194.501653,118 194.181787,118 183.793701,118 C183.747463,118 183.702166,117.997232 183.657797,117.991761 Z"
                id="folder-front"
                fill="#4F8DF9"
            ></path>
            <g
                id="magnifying"
                transform="translate(48.000000, 77.000000)"
            >
                <path
                    d="M7.44116113,31.7632433 L19.935123,31.7682572 L19.9574424,49.7020953 C19.9613271,52.8234489 17.4341192,55.3569551 14.3127656,55.3608398 C14.309665,55.3608436 14.3065643,55.3608449 14.3034637,55.3608437 L13.1129463,55.3603659 C9.99522252,55.3591148 7.46738387,52.8334068 7.46350373,49.7156852 L7.44116113,31.7632433 Z"
                    id="Rectangle-4-Copy-3"
                    fill="#1B2653"
                    transform="translate(13.700618, 43.561926) rotate(-315.000000) translate(-13.700618, -43.561926) "
                ></path>
                <ellipse
                    id="Oval-5-Copy-3"
                    fill="#3063BB"
                    cx="35.1388712"
                    cy="24.3877358"
                    rx="24.3055379"
                    ry="24.3877358"
                ></ellipse>
                <ellipse
                    id="Oval-5-Copy-4"
                    fill="#FFFFFF"
                    cx="34.9808008"
                    cy="24.2140667"
                    rx="15.5343722"
                    ry="15.5916178"
                ></ellipse>
            </g>
            <g
                id="v-check"
                transform="translate(204.000000, 0.000000)"
            >
                <circle
                    id="Oval"
                    fill="#1EC794"
                    fillRule="nonzero"
                    cx="18.3727724"
                    cy="18"
                    r="18"
                ></circle>
                <g
                    id="Icon/Check"
                    transform="translate(0.372772, 0.000000)"
                >
                    <g
                        id="Monthly-Visits"
                        transform="translate(7.500000, 6.000000)"
                    >
                        <mask
                            id="mask-2"
                            fill="white"
                        >
                            <use href="#path-1"></use>
                        </mask>
                        <use
                            id="Rectangle"
                            fill="#FFFFFF"
                            fillRule="nonzero"
                            transform="translate(9.918655, 10.668655) scale(1, -1) rotate(-45.000000) translate(-9.918655, -10.668655) "
                            href="#path-1"
                        ></use>
                    </g>
                </g>
            </g>
            <circle
                id="sparkle-5"
                fill="#FFC100"
                fillRule="nonzero"
                cx="251.5"
                cy="70.5"
                r="6.5"
            ></circle>
            <circle
                id="sparkle-4"
                fill="#EDF2F7"
                fillRule="nonzero"
                cx="39"
                cy="49"
                r="11"
            ></circle>
            <circle
                id="sparkle-3"
                fill="#EDF2F7"
                fillRule="nonzero"
                cx="281"
                cy="97"
                r="11"
            ></circle>
            <circle
                id="sparkle-2"
                fill="#EDF2F7"
                fillRule="nonzero"
                cx="138.5"
                cy="150.5"
                r="8.5"
            ></circle>
            <circle
                id="sparkle-1"
                fill="#FFC100"
                fillRule="nonzero"
                cx="5.5"
                cy="81.5"
                r="5.5"
            ></circle>
        </g>
    </svg>
);
